


<div class="col-12 menu noPLPR">
  <header id="header" class="header dhl redesign">
    <div class="header__secondaryNavigation">
      <ul role="tablist" class="tabnav">
        <li *ngFor="let nodo of nodeHeadboard?.childNodes;let i = index">
          <a [href]="nodo.url" class="header-tab" [ngClass]="{'active': nodo == nodeSelectedTab}">
            {{nodo.title}}
          </a>
        </li>
      </ul>
    </div>

    <nav class="headerPrimario navbar navbar-expand-lg" style="height: 90px;">
      <div class="container-fluid">

        <div class="navbar-header">
          <button type="button" class="navbar-toggle" (click)="clickMenuMobile()">
            <span id="toggleLabel" class="visually-hidden">Toggle</span>
            <span class="bi bi-list" ></span>
          </button>
          <a class="navbar-brand" [href]="urlBussines">
            <img alt="Brand" src="{{directoryImages}}/assets/images/dhl-official.png">
          </a>
        </div>
        <div id="bs-example-navbar-collapse-2" class="header__navigationWrapper collapse navbar-collapse navbar-right">
          <ul class="nav navbar-right">
            <li class="nav-item" style="padding: 12px;"
             #dd="bs-dropdown" *ngFor="let nodo of nodeSelectedTab?.childNodes" dropdown [triggers]="openMenusOnHover ? 'hover' : 'click'" (mouseenter)="mouseDropdown($event, dd, true);" (mouseleave)="mouseDropdown($event, dd, false);">
              <a target="_blank" [href]="nodo.url" dropdownToggle>{{nodo.title}} <span class="caret"></span></a>
              <ng-container *ngIf="hasChildren(nodo)">
                <ul *dropdownMenu class="dropdown-menu" role="menu" style="border-radius: 0;">
                  <li *ngFor="let hijo of nodo.childNodes">
                    <a target="_blank" [href]="hijo.url">{{hijo.title}}<span class="caret"></span></a>
                  </li>
                </ul>
              </ng-container>
          </ul>
        </div>
      </div>
    </nav>

    <div #menuPhone id="bs-example-navbar-collapse-1" class="header__navigationWrapper navbar-default hidden" role="menu">
      <ul class="nav navbar-nav" *ngIf="hasChildren(nodeSelectedTab)">
        <li dropdown *ngFor="let nodo of nodeSelectedTab?.childNodes" [ngClass]="{'dropdown': hasChildren(nodo)}">
          <a target="_blank" [href]="nodo.url">
            {{nodo.title}}
            <button *ngIf="hasChildren(nodo)" class="dropdown-toggle" dropdownToggle (click)="clickMenu(nodo)"><span class="bi bi-plus-lg"></span></button>
          </a>
          <ng-container *ngIf="hasChildren(nodo)">
            <ul class="dropdown-menu" *dropdownMenu>
              <li role="menuitem" *ngFor="let hijo of nodo.childNodes"><a target="_blank" [href]="hijo?.url">{{hijo.title}}</a></li>
            </ul>
          </ng-container>
        </li>
        <li *ngFor="let nodo of nodeHeadboard?.childNodes;let i = index">
          <a target="_blank" [href]="nodo.url" >
            {{nodo.title}}
          </a>
        </li>
      </ul>
    </div>
  </header>
</div>
